import { ExaminationSessionList } from './../../model/examination-session.model';
import { HttpParams } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export enum ExaminationSessionTypes {
    GET_ExaminationSession = '[ExaminationSession] Get ExaminationSession',
    GET_ExaminationSession_SUCCESS = '[ExaminationSession] Get ExaminationSession Success',
    GET_ExaminationSession_FAILURE = '[ExaminationSession] Get ExaminationSession Failure',
}

export const GetExaminationSession = createAction(
    ExaminationSessionTypes.GET_ExaminationSession,
    props<{ params: HttpParams }>()
)

export const GetExaminationSessionSuccess = createAction(
    ExaminationSessionTypes.GET_ExaminationSession_SUCCESS,
    props<{ payload: ExaminationSessionList }>()
)

export const GetExaminationSessionFailure = createAction(
    ExaminationSessionTypes.GET_ExaminationSession_FAILURE,
)